export default "__VITE_ASSET__CeLXjs$b__"